<div class="select-text-wrapper">
    <strong class="label">{{ element.label | htmlDecode }} </strong>
    <ng-container *ngFor="let selection of getSelectedElements()">
        <span>{{ getSelectionName(selection) }}</span>
    </ng-container>
</div>